import { Brand, Enterprise } from 'apis/enterprise/types';
import { MerchantDetail } from 'apis/restaurant-api/merchant-admin/merchant/types';
import { Venue } from 'apis/restaurant-api/merchant-admin/venue/types';

export type ExperienceEntityObject = Enterprise | Brand | MerchantDetail | Venue;
export type ExperienceEntityId = string;
export enum ExperienceEntityType {
  ENTERPRISE = 'enterprise',
  BRAND = 'brand',
  MERCHANT = 'merchant',
  VENUE = 'venue',
}

export type ExperienceEnterpriseEntity = {
  experienceEntityType: ExperienceEntityType.ENTERPRISE;
  experienceEntityId: ExperienceEntityId;
  experienceEntityObject: Enterprise;
};
export type ExperienceBrandEntity = {
  experienceEntityType: ExperienceEntityType.BRAND;
  experienceEntityId: ExperienceEntityId;
  experienceEntityObject: Brand;
};
export type ExperienceMerchantEntity = {
  experienceEntityType: ExperienceEntityType.MERCHANT;
  experienceEntityId: ExperienceEntityId;
  experienceEntityObject: MerchantDetail;
};
export type ExperienceVenueEntity = {
  experienceEntityType: ExperienceEntityType.VENUE;
  experienceEntityId: ExperienceEntityId;
  experienceEntityObject: Venue;
};

export type ExperienceEntity =
  | ExperienceEnterpriseEntity
  | ExperienceBrandEntity
  | ExperienceMerchantEntity
  | ExperienceVenueEntity;

export type ExperienceEntityTree = {
  experienceEntity: ExperienceEntity;
  children: ExperienceEntityTree[];
};

export type ExperienceRouteParams = {
  experienceEntityType?: ExperienceEntityType;
  experienceEntityId?: ExperienceEntityId;
};

export enum NavigationKey {
  INSIGHTS = 'INSIGHTS',
  BEST_OF_WOLT = 'BEST_OF_WOLT',
  ACCESS_MANAGEMENT = 'ACCESS_MANAGEMENT',
  BUSINESS_DETAILS = 'BUSINESS_DETAILS',
  PURCHASES = 'PURCHASES',
  TRANSLATION = 'TRANSLATION',
  CAMPAIGNS = 'CAMPAIGNS',
  MENU_EDITOR = 'MENU_EDITOR',
  VENUES = 'VENUES',
  SETTLEMENTS = 'SETTLEMENTS',
}

export type NavigationItem = {
  intlKey: string;
  link: string;
  key: NavigationKey;
  trackingKey?: string;
  isVenueSpecific: boolean;
};
